import {
  FETCH_COMMISSION_SUCCESS,
  FETCH_COMMISSION_BY_TIME_SUCCESS,

} from '../actions/commission/action_types';

export default (state = {
  commission: [],
  commissionByTime: [],
}, action) => {
  switch (action.type) {
    case FETCH_COMMISSION_SUCCESS:
      return {
        ...state,
        commission: action.data,
      };
    case FETCH_COMMISSION_BY_TIME_SUCCESS:
      return {
        ...state,
        commissionByTime: action.data,
      };
    default:
      return {
        ...state,
      };
  }
};
